<template>
  <div>
    <div v-if="hasSubmissionId" class="max-w-lg w-full mx-auto">
      <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0" v-if="error == ''">
      <div class="mt-10 mx-auto max-w-7xl px-4 sm:mt-20 sm:px-6">
        <div class="text-center">
          <h1
            v-if="!headless"
            class="tracking-tight font-black text-gray-900 text-2xl md:text-3xl"
          >
            <span class="">Congratulations</span> -
            <span class="">{{ clip.registration.name }}</span>
          </h1>
          <h1
            class="text-5xl tracking-tight font-extrabold text-gray-900 sm:text-2xl md:text-4xl mt-4 mb-2"
          >
            
          </h1>
          <div id="video-container">
          <p
            class="mt-3 max-w-md mx-auto text-base text-gray-700 sm:text-lg md:mt-5 md:text-xl md:max-w-3xl"
          >
            <video
              :autoplay="autoplay"
              controls
              ref="video"
              :src="clip.url"
              :poster="clip.poster"
              preload="metadata"
              playsinline
              @pause="
                trackEvent($route.path, {
                  label: 'VIDEO_PAUSE',
                  type: 'GRADAUTIONCLIP',
                  submission_id: clip.submission.id,
                  registration_id: clip.registration.id,
                })
              "
              @play="
                trackEvent($route.path, {
                  label: 'VIDEO_PLAY',
                  type: 'GRADAUTIONCLIP',
                  submission_id: clip.submission.id,
                  registration_id: clip.registration.id,
                })
              "
              @ended="
                trackEvent($route.path, {
                  label: 'VIDEO_ENDED',
                  type: 'GRADAUTIONCLIP',
                  submission_id: clip.submission.id,
                  registration_id: clip.registration.id,
                })
              "
            />
          </p>
          <br />
          <div  v-show="showModal && !headless" class="modal">
            <!-- Modal content with share buttons -->
            <div class="modal-content">
              <span class="close" @click="closeModal">&times;</span>
              <h2
                class="text-2xl tracking-tight font-extrabold text-gray-900 sm:text-2xl md:text-2xl"
              >
                <span class="block text-mygrad">Share your GraduationClip now!</span>
              </h2>
              <div
                class="a2a_kit a2a_kit_size_64 a2a_default_style"
                data-a2a-title="MyGraduationClip"
                id="shareButtons"
              >
                <a class="a2a_button_whatsapp"></a>
                <a class="a2a_button_linkedin"></a>
                <a class="a2a_button_facebook"></a>
                <a class="a2a_button_twitter"></a>
                <a class="a2a_button_wechat"></a>
                <a class="a2a_dd" href="https://www.addtoany.com/share"></a>
              </div>
            </div>
          </div>
          <div  v-show="showModalPurchase && !headless" class="modal" style="z-index:999;">
            <!-- Modal content with share buttons -->
            <div class="modal-content">
              <span class="close" @click="closeModalPurchase">&times;</span>
              <h2
                class="text-2xl tracking-tight font-extrabold text-gray-900 sm:text-2xl md:text-2xl"
              >
                <span class="block text-mygrad">Why not also get the Full Length Graduation film?</span>
              </h2>
              <button
                type="submit"
                :disabled=purchaseButtonDisabled
                @click="buyCeremony"
                class="text-center mt-3 items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 margin-sm"
                style="background-color: #0d9b00;color: #fff;font-size: large;padding: 1em;"
                >
                <b>{{purchaseButtonText}}</b>
              </button>
            </div>
          </div>
          <div v-if="needsUpdate" class="modal" style="z-index:1000;">
            <!-- WARNING: only missing additional fields are supplied. Any
                   conditions depending on other fields may break. -->
            <div class="modal-content">
              <RegistrationForm
                :hideNameEmail="true"
                :events="organiser.ceremonies"
                :additional-fields-input="updateInfo.missing_fields"
                :name="updateInfo.registration.name"
                :email="updateInfo.registration.email"
                :event="updateInfo.registration.ceremony"
                :organiserSlug="organiser.slug"
                :hideEvent="true"
                @submit="submitUpdate"
                :forceStep="2"
              />
            </div>
          </div>
          </div>
          <h2
            class="text-2xl tracking-tight font-extrabold text-gray-900 sm:text-2xl md:text-2xl"
          >
            <span class="block text-mygrad-light">{{ organiser.name }}</span>
          </h2>
          <div
            class="mt-3 max-w-md mx-auto text-base text-gray-700 sm:text-lg md:mt-5 md:text-xl md:max-w-3xl justify-center items-center"
          >
            <div
              class="a2a_kit a2a_kit_size_32 a2a_default_style"
              data-a2a-title="MyGraduationClip"
              id="shareButtons"
            >
              <a class="a2a_button_whatsapp"></a>
              <a class="a2a_button_linkedin"></a>
              <a class="a2a_button_facebook"></a>
              <a class="a2a_button_twitter"></a>
              <a class="a2a_button_wechat"></a>
              <a class="a2a_dd" href="https://www.addtoany.com/share"></a>
            </div>
          </div>
          <div>
                      <button
              type="submit"
              @click="download"
              class="text-center mt-3 flex justify-center gap-1.5 items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-white w-full bg-blue-500 hover:bg-blue-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 margin-sm"
            >
              Download my GraduationClip
            </button>
          </div>
          <div
            class="mt-2 max-w-md mx-auto text-base text-gray-700 sm:text-lg md:mt-3 md:text-xl md:max-w-3xl grid grid-cols-1 md:grid-cols-2 gap-2 content-center"
          >

            <button
              type="submit"
              @click="referAFriend"
              class="flex gap-1.5 justify-center text-center mt-3 w-full items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 margin-sm"
            >
               <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.1998 5.32676C7.1998 6.65224 6.12529 7.72676 4.7998 7.72676C3.47432 7.72676 2.3998 6.65224 2.3998 5.32676C2.3998 4.00127 3.47432 2.92676 4.7998 2.92676C6.12529 2.92676 7.1998 4.00127 7.1998 5.32676Z" fill="#6B7280"/>
                <path d="M13.5998 5.32676C13.5998 6.65224 12.5253 7.72676 11.1998 7.72676C9.87432 7.72676 8.7998 6.65224 8.7998 5.32676C8.7998 4.00127 9.87432 2.92676 11.1998 2.92676C12.5253 2.92676 13.5998 4.00127 13.5998 5.32676Z" fill="#6B7280"/>
                <path d="M10.3431 14.1268C10.3805 13.8655 10.3998 13.5984 10.3998 13.3268C10.3998 12.0186 9.95128 10.8152 9.19961 9.86201C9.788 9.5216 10.4712 9.32676 11.1998 9.32676C13.409 9.32676 15.1998 11.1176 15.1998 13.3268V14.1268H10.3431Z" fill="#6B7280"/>
                <path d="M4.7998 9.32676C7.00894 9.32676 8.7998 11.1176 8.7998 13.3268V14.1268H0.799805V13.3268C0.799805 11.1176 2.59067 9.32676 4.7998 9.32676Z" fill="#6B7280"/>
                </svg>
                Refer a friend
            </button>
            <!--
            <button
              type="submit"
              @click="changeClip"
              class="text-center mt-3 items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              Edit my GraduationClip
            </button>
            <button
              type="submit"
              @click="changeAudio"
              class="text-center mt-3 items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              Adjust my sound
            </button>
          -->
            <button v-if="this.organiser.slug != 'city-london'"
              type="submit"
              @click="faqHelp"
              class="flex gap-1.5 justify-center text-center w-full mt-3 items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path fill-rule="evenodd" clip-rule="evenodd" d="M21.6004 12.4999C21.6004 17.8018 17.3023 22.0999 12.0004 22.0999C6.69846 22.0999 2.40039 17.8018 2.40039 12.4999C2.40039 7.19797 6.69846 2.8999 12.0004 2.8999C17.3023 2.8999 21.6004 7.19797 21.6004 12.4999ZM12.0004 8.8999C11.5577 8.8999 11.1695 9.13896 10.9602 9.50077C10.6284 10.0744 9.89429 10.2705 9.32061 9.93863C8.74694 9.60678 8.55091 8.8727 8.88276 8.29903C9.5034 7.22612 10.6664 6.4999 12.0004 6.4999C13.9886 6.4999 15.6004 8.11168 15.6004 10.0999C15.6004 11.6674 14.5986 13.0009 13.2004 13.4951V13.6999C13.2004 14.3626 12.6631 14.8999 12.0004 14.8999C11.3377 14.8999 10.8004 14.3626 10.8004 13.6999V12.4999C10.8004 11.8372 11.3377 11.2999 12.0004 11.2999C12.6631 11.2999 13.2004 10.7626 13.2004 10.0999C13.2004 9.43716 12.6631 8.8999 12.0004 8.8999ZM12.0004 18.4999C12.6631 18.4999 13.2004 17.9626 13.2004 17.2999C13.2004 16.6372 12.6631 16.0999 12.0004 16.0999C11.3376 16.0999 10.8004 16.6372 10.8004 17.2999C10.8004 17.9626 11.3376 18.4999 12.0004 18.4999Z" fill="#6B7280"/>
                                </svg>  Get Help
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0" v-if="error != ''">
      <div class="mt-8 mx-auto max-w-7xl px-4 sm:mt-4 sm:px-6">
        <div class="text-center">
          <h1
            class="text-4xl tracking-tight font-extrabold text-gray-900 sm:text-5xl md:text-6xl"
          >
            <span class="block">Your clip is not ready yet!</span>
          </h1>
          <h1
            class="text-5xl tracking-tight font-extrabold text-gray-900 sm:text-2xl md:text-4xl mt-4 mb-2"
          >
            <span class="block text-mygrad">Come back in a few minutes.</span>
          </h1>
        </div>
      </div>
    </div>
    </div>
    <div v-else class="md:w-1/2 sm:w-full mx-auto mt-8 space-y-4">
      <h1 class="text-4xl text-center tracking-tight font-extrabold text-gray-900 sm:text-5xl md:text-6xl mb-6">
        <span class="block">Search for your GraduationClip</span>
      </h1>
      <input
        v-model="searchQuery"
        @input="onSearchInput"
        type="text"
        placeholder="Search for your name"
        class="w-full p-2 border rounded"
      />
      <div v-if="searchResults.length" class="grid gap-4">
        <div
          v-for="result in searchResults"
          :key="result.id"
          class="p-4 bg-white rounded shadow hover:bg-gray-100 cursor-pointer transition-colors"
          @click="$router.push({path: `/clip/${$route.params.uni}/${result.id}`})"
        >
          <h3 class="text-lg font-bold">{{ result.name }}</h3>
          <p class="text-gray-600">{{ formatDateTime(result.datetime) }}</p>
        </div>
      </div>
      <div v-else-if="searchQuery.length == 0 && searchQuery !== ''" class="text-gray-500">
        No results found for "{{ searchQuery }}". Please try a different name.
      </div>
    </div>
  </div>
</template>
<script src="https://static.addtoany.com/menu/page.js"></script>

<script>
import axios from "axios";
import Auth from "../api/auth";
import { trackEvent } from "../Analytics.vue";
import RegistrationForm from "./Registration/RegistrationForm.vue";
import moment from "moment";

export default {
  name: "DeliveryPage",
  props: { organiser: Object },
  data: function () {
    return {
      clip: {},
      error: "",
      showModal: false,
      purchaseButtonText: "Get the full ceremony film!",
      purchaseButtonDisabled: false,
      showModalPurchase: false,
      digitalDownloadAvailable: false,
      needsUpdate: false,
      updateInfo: null,
      autoplay: true, // Set to true to autoplay the video
      searchQuery: "",
      searchResults: [],
      searchTimeout: null,
      currentSearchRequest: null,
    };
  },
  created() {
    this.loadDeliveryData();
  },
  methods: {
    loadDeliveryData() {
      // Get query parameters from $route
      const email = this.$route.query.email;
      const isHeadless = this.$route.query.headless;
      // Extract university slug from the path
      const pathParts = window.location.pathname.split('/');
      const uniSlug = pathParts[2];

      if (!this.$route.params.id && !email) {
        // show search interface when no clip identifier or email is supplied
        return;
      }

      if (isHeadless) {
        axios
          .post(
            `/clips/email`,
            {
              email: email,
              slug: uniSlug
            },
            {
              headers: {
                Authorization: "Bearer " + this.getRequestToken(),
              },
            }
          )
          .then((response) => response.data)
          .then((response_data) => this.setData(response_data, isHeadless))
          .catch(
            (error) => {
              if (
                error.response &&
                error.response.status === 403 &&
                error.response.data.update_token
              ) {
                this.autoplay = false; // Disable autoplay if update is needed
                this.needsUpdate = true;
                this.updateInfo = error.response.data;
                this.setData(error.response.data);
              } else if (
                error.response &&
                error.response.status === 404 &&
                error.response.data.error === "Registration not found"
              ) {
                this.error = error.response.data.error
                trackEvent(this.$route.path, {
                  label: "REGISTRATION_NOT_FOUND",
                  submission_id: "Email Search",
                });
                // Redirect to university registration page
                this.$router.push(`/${uniSlug}-register?headless=1`);
              } else if (
                error.response &&
                error.response.status === 400 &&
                error.response.data.error === "Email required"
              ) {
                this.error = error.response.data.error
                trackEvent(this.$route.path, {
                  label: "EMAIL_NOT_FOUND_GET_CLIP",
                  submission_id: "Email Search",
                });
              } else if (
                error.response &&
                error.response.status === 404 &&
                error.response.data.error === "Clip not made"
              ) {
                this.error = error.response.data.error
                // Redirect to university registration page
                this.$router.push(`/thumbnails/${uniSlug}/${error.response.data.registration_id}?headless=1`);
              } else {
                this.error = error.response.error;
                trackEvent(this.$route.path, {
                  label: "GRADUATIONCLIP_NOT_READY",
                  submission_id: "Email Search",
                });
              }
            }
          );
        return;
      }

      const clipId = this.$route.params.id;
      axios
        .get(`/clips/${clipId}`, {
          headers: {
            Authorization: "Bearer " + this.getRequestToken(),
          },
        })
        .then((response) => response.data)
        .then((response_data) => this.setData(response_data))
        .catch(
          (error) => {
            if (
              error.response &&
              error.response.status === 403 &&
              error.response.data.update_token
            ) {
              this.autoplay = false; // Disable autoplay if update is needed
              this.needsUpdate = true;
              this.updateInfo = error.response.data;
              this.setData(error.response.data);
            } else {
              this.error = error.response.error;
              trackEvent(this.$route.path, {
                label: "GRADUATIONCLIP_NOT_READY",
                submission_id: this.$route.params.id,
              });
            }
          }
        );
    },
    getRequestToken() {
      return Auth.getPublicRequestToken();
    },
    checkVideoProgress() {
      const videoElement = this.$refs.video; // Add a ref="video" to your video tag
      if (videoElement) {
        const currentTime = videoElement.currentTime;
        const duration = videoElement.duration;
        if (currentTime / duration > 0.85) {
          // Example: 85% of the video has played
          this.showModal = true;
          if (this.digitalDownloadAvailable) {
            this.showModalPurchase = true;
            trackEvent(this.$route.path, {
              label: "DIGITAL_DOWNLOAD_PURCHASE_MODAL_OPENED",
              registration_id: this.clip.registration.id,
              submission_id: this.clip.submission.id,
            });
          }
          clearInterval(this.videoCheckInterval);
          trackEvent(this.$route.path, {
            label: "SHARE_MODAL_OPENED",
            registration_id: this.clip.registration.id,
            submission_id: this.clip.submission.id,
          }); 
          
        }
      }
    },
    onSearchInput() {
      if (this.searchQuery.length > 2) {
        if (this.searchTimeout) clearTimeout(this.searchTimeout);
        this.searchTimeout = setTimeout(this.searchClips, 200);
      } else {
        this.searchResults = [];
      }
    },
    searchClips() {
      // Cancel any in-flight requests
      if (this.currentSearchRequest) {
        this.currentSearchRequest.cancel();
      }
      
      // Create a new cancel token
      const CancelToken = axios.CancelToken;
      const source = CancelToken.source();
      this.currentSearchRequest = source;
      
      const query = this.searchQuery.toLowerCase();
      
      // Make the request with the cancel token
      axios
        .get(`/clips/search`, {
          params: { slug: this.organiser.slug, name: this.searchQuery },
          cancelToken: source.token
        })
        .then((r) => {
          // Only update if this is still the current search query
          if (this.searchQuery.toLowerCase() === query) {
            this.searchResults = r.data.clips || [];
          }
        })
        .catch((err) => {
          // Ignore cancellation errors
          if (!axios.isCancel(err)) {
            console.error('Search error:', err);
          }
        });
    },
    formatDateTime(dt) {
      return moment(dt).format("MMMM Do YYYY, h:mm a");
    },
    closeModalPurchase() {
      this.showModalPurchase = false;
      trackEvent(this.$route.path, {
            label: "DIGITAL_DOWNLOAD_PURCHASE_MODAL_CLOSED",
            registration_id: this.clip.registration.id,
            submission_id: this.clip.submission.id,
          });  
    },
    closeModal() {
      this.showModal = false;
      trackEvent(this.$route.path, {
            label: "SHARE_MODAL_CLOSED",
            registration_id: this.clip.registration.id,
            submission_id: this.clip.submission.id,
          });  
    },
    download() {
      const clipId = this.clip.submission.id;
      const token = this.getRequestToken();
      trackEvent(this.$route.path, {
        label: "DOWNLOAD_CLIP",
        registration_id: this.clip.registration.id,
        submission_id: clipId,
      });
      window.open(
        `${process.env.VUE_APP_BASE_URL}/clips/${clipId}/download?authToken=${token}`,
        "_blank"
      );
    },
    referAFriend() {
      trackEvent(this.$route.path, {
        label: "REFER_CLICK",
        registration_id: this.clip.registration.id,
        submission_id: this.clip.submission.id,
      });
      window.open("https://mygraduationclip.com/#links", "_blank");
    },
    setData(clip, headless = false) {
      this.clip = clip;
      if(!headless){
        this.clip.submission.id = this.$route.params.id;
      }
      trackEvent(this.$route.path, {
        label: "GRADUATIONCLIP_VIEW",
        registration_id: this.clip.registration.id,
        submission_id: this.clip.submission.id,
      });
    },
    changeClip() {
      trackEvent(this.$route.path, {
        label: "CHANGE_CLIP_CLICK",
        registration_id: this.clip.registration.id,
        submission_id: this.clip.submission.id
      });
      this.$router.push(
        `/submission/${this.clip.registration.id}?uni=${this.organiser.slug}&timecode=${this.clip.submission.in_point}&initial_in=${this.clip.submission.in_point}&initial_out=${this.clip.submission.out_point}&source_submission=${this.clip.submission.id}`
      );
    },
    changeAudio() {
      trackEvent(this.$route.path, {
        label: "CHANGE_AUDIO_CLICK",
        registration_id: this.clip.registration.id,
        submission_id: this.clip.submission.id,
      });
      this.$router.push(
        `/submission/${this.clip.registration.id}?uni=${this.organiser.slug}&timecode=${this.clip.submission.in_point}&initial_in=${this.clip.submission.in_point}&initial_out=${this.clip.submission.out_point}&source_submission=${this.clip.submission.id}`
      );
    },
    buyCeremony() {
      if (this.purchaseButtonDisabled) {
        return;
      }
      this.purchaseButtonText = "Taking you there...";
      this.purchaseButtonDisabled = false;
      window.open(
        `/store/${this.organiser.slug}/purchase/digital-download`
      );
      return;
      axios({"method": "POST",
        "baseURL":  process.env.VUE_APP_DIGITAL_DOWNLOAD_BASE_URL,
        "url": "/purchase",
          "data": {
            name: this.clip.registration.name,
            email: this.clip.registration.email,
            ceremony: this.clip.registration.ceremony
          }
        })
        .then((r) => {
          this.url = r.data;
          trackEvent(this.$route.path, {label: "DIGITAL_DOWNLOAD_CLIP_VIEW_PURCHASE_CLICK", paid: false})
          window.location.href = r.data;
        });
    },
    faqHelp() {
      trackEvent(this.$route.path, {
        label: "FAQ_HELP_CLICK",
        registration_id: this.clip.registration.id,
        submission_id: this.clip.submission.id,
      });
      window.open(`/clip/${this.organiser.slug}/${this.clip.submission.id}/help`);
    },
    submitUpdate(formData) {
      const mapped = {};
      formData["additionalFields"].forEach((item) => {
        mapped[item["name"]] = item["value"];
      });
      axios
        .put(
          `/registrations/${this.updateInfo.registration.id}?token=${this.updateInfo.update_token}`,
          {
            //name: formData["name"],
            //email: formData["email"],
            ceremony: formData["event"],
            additionalFields: mapped,
          }
        )
        .then(() => {
          this.needsUpdate = false;
          this.loadDeliveryData();
        });
    },
    trackEvent,
  },
  computed: {
    headless() {
      return this.$route.query.headless !== undefined;
    },
    hasSubmissionId() {
      // treat the presence of an email query parameter as providing a clip id
      // so that the search interface doesn't show during automatic lookup
      return (
        this.$route.params.id !== undefined || this.$route.query.email !== undefined
      );
    }
  },
  mounted() {
    axios({"method": "GET",
        "baseURL":  process.env.VUE_APP_DIGITAL_DOWNLOAD_BASE_URL,
        "url": `/availability/${this.organiser.id}`
        })
        .then(() => {
          this.digitalDownloadAvailable = true;
        }).catch(() => {
          this.digitalDownloadAvailable = false;
        });
    this.videoCheckInterval = setInterval(this.checkVideoProgress, 1000); // Check every second

    const recaptchaScript = document.createElement("script");
    recaptchaScript.setAttribute(
      "src",
      "https://static.addtoany.com/menu/page.js"
    );
    document.head.appendChild(recaptchaScript);
    let recaptchaScriptIsReady = false;
    var self = this;

    let checkInterval = setInterval(
      function () {
        console.log("Checking");
        if (typeof window !== "undefined" && window.a2a) {
          window.a2a_config = window.a2a_config || {};
          window.a2a_config.templates = window.a2a_config.templates || {};

          window.a2a_config.callbacks = window.a2a_config.callbacks || [];
          const tpl = (this.organiser && this.organiser.shareTemplates) || {};

          // Sensible defaults if no templates provided
          const defaultLine = "Watch my personalised GraduationClip from " + this.organiser.name + " ${link}";

          window.a2a_config.templates.whatsapp = {
            text: (tpl.whatsapp && tpl.whatsapp.text) || defaultLine,
          };
          window.a2a_config.templates.sms = {
            body: (tpl.sms && tpl.sms.body) || defaultLine,
          };
          window.a2a_config.templates.email = {
            text: (tpl.email && tpl.email.text) || defaultLine,
          };
          window.a2a_config.templates.twitter = {
            text: (tpl.twitter && tpl.twitter.text) || defaultLine,
            related: (tpl.twitter && tpl.twitter.related) || "MyGraduationClip,GraduationClip,Graduation",
            hashtags: (tpl.twitter && tpl.twitter.hashtags) || undefined,
          };
          window.a2a_config.templates.linkedin = {
            text: (tpl.linkedin && tpl.linkedin.text) || ("I'm incredibly proud to share my personalised GraduationClip from " + this.organiser.name + " ${link}"),
          };

          window.a2a_config.callbacks = [
            {
              share: (e) => {
                console.log(e);
                trackEvent(window.location.pathname, {
                  label: "SHARE",
                  service: e.serviceCode,
                  url: e.url,
                  title: e.title,
                  service_readable_name: e.service,
                  registration_id: self.clip.registration.id,
                  submission_id: self.clip.submission.id,
                });
              },
            },
          ];
          recaptchaScriptIsReady = true;
          clearInterval(checkInterval);

          window.a2a.init_all();
        }
        return recaptchaScriptIsReady;
      }.bind(self),
      2000
    );
  },
  components: { RegistrationForm },
  beforeDestroy() {
    if (this.videoCheckInterval) {
      clearInterval(this.videoCheckInterval);
    }
  },
};
</script>
<style scoped>
#shareButtons {
  display: flex;
  padding: 10px !important;
  justify-content: center !important;
  flex-wrap: wrap;
}
.a2a_default_style:not(.a2a_flex_style) a {
  margin: 4px 0;
}
.modal {
  position: absolute; /* Stay in place */
  z-index: 1; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: #daf6ff; /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */

}

.modal-content {
  background-color: #daf6ff;
  margin: 15% auto; /* 15% from the top and centered */
  padding: 20px;
  border: 1px solid #888;
  width: 80%; /* Could be more or less, depending on screen size */
  border: 2px solid #08697b; /* Black border, you can change the color */
  border-radius: 10px; /* Rounded corners */
}

.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}
.video-container {
    position: relative;
}
</style>
